import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content",
  role: "tabpanel"
}
const _hoisted_2 = { class: "filter-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["aria-label", "placeholder", "onKeyup"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  key: 0,
  class: "selected-filter-circle"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "search-result-text col" }
const _hoisted_12 = { class: "grey overview-items-count" }
const _hoisted_13 = { class: "video-stop col" }
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = {
  class: "video-stop-text",
  for: "stop-video-button"
}
const _hoisted_16 = {
  key: 1,
  class: "no-result"
}

import { StoryDto } from '@/models/FilterPageTypes'
import { useFilterPageStore } from '@/stores/filterPageStore'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import StoryCollectionsSearchModal from './StoryCollectionsSearchModal.vue'
import StoryDetailsModal from './StoryDetailsModal.vue'
import StoryPreviewItem from './StoryPreviewItem.vue'
import { useRouter } from 'vue-router'
import { WINDOW_WIDTH } from '@/models/WidthTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryCollections',
  setup(__props) {

const router = useRouter()

const storyMosaic = ref<HTMLElement | undefined>(undefined)
const selectedStory = ref<StoryDto | undefined>(undefined)
const searchQuery = ref<string>("");
const areVideosStopped = ref<boolean>(false);

const filterPageStore = useFilterPageStore()

let columnsNumber = computed(() => {
    return window.innerWidth > WINDOW_WIDTH.lg ? 4 : 2
})

const stories = computed(() => filterPageStore.shuffleStoryCreationInto(filterPageStore.stories))
const storiesDescr = computed(() => filterPageStore.storiesDescr)
const storiesShareLinks = computed(() => filterPageStore.storiesShareLinks)
const storiesPageTitle = computed(() => filterPageStore.storiesPageTitle)

const searchPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.SearchPlaceholder') ?? '')
const resultsCountMessage = computed(() => {
    const trans = filterPageStore.getLocalization('FilterPage.StoryCollection.ResultsCountMessage') ?? ''

    if (filterPageStore.totalStories > 0 && trans.length > 0) {
        return trans.replace('{{count}}', filterPageStore.totalStories.toString())
    }

    return ''
})
const noResultsText = computed(() => {
    const trans = filterPageStore.getLocalization('FilterPage.StoryCollection.NotFound.NoResults') ?? ''

    if (stories.value.length < 1 && trans.length > 0) {
        return trans.replace('{{inputValue}}', searchQuery.value ?? '')
    }

    return ''
})
const tryAnotherWordText = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.NotFound.TryAnotherWord'))
const stopVideosText = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.VideoStopText'))
const filterPlaceholder = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.FilterPlaceholder') ?? '')
const clearFiltersButton = computed(() => filterPageStore.getLocalization('FilterPage.StoryCollection.Filter.ClearButton') ?? '')
const ariaLabelSearch = computed(() => filterPageStore.getLocalization("Accessability.Search.Description"))
const ariaLabelSearchButton = computed(() => filterPageStore.getLocalization("Accessability.Search.SearchButton"))
const ariaLabelClearButton = computed(() => filterPageStore.getLocalization("Accessability.Search.Clear"))
const playVideosText = computed(() => filterPageStore.getLocalization("Accessability.Videos.Play"))
const allPickedFitlers = computed(() => filterPageStore.getLocalization("Accessability.Filter.AllPickedFilters"))

const landingPageLink = computed(() => filterPageStore.landingPageLink)
const isStoriesFethcing = computed(() => filterPageStore.isStoriesFetching)
const isAnyFiltersPushed = computed(() => filterPageStore.isAnyFiltersPushed())

const isAnyFilters = computed(() => {
    if (filterPageStore.storySearchModel.timeType) {
        if (filterPageStore.storySearchModel.timeType === '1' && filterPageStore.storySearchModel.yearsRange.length) {
            return true
        }
        if (filterPageStore.storySearchModel.timeType === '2' && filterPageStore.storySearchModel.timeTags.length) {
            return true
        }
    }

    if (filterPageStore.storySearchModel.locationType) {
        if (filterPageStore.storySearchModel.locationType === '1' && filterPageStore.storySearchModel.locationQuery) {
            return true
        }
        if (filterPageStore.storySearchModel.locationType === '2' && filterPageStore.storySearchModel.locationTags.length) {
            return true
        }
    }

    if (filterPageStore.storySearchModel.storytellerTags.length || filterPageStore.storySearchModel.contentTags.length) {
        return true
    }

    return false
})

const selectedFilters = computed(() => {
    const result = [
        selectedTimeFilters.value,
        selectedLocationFilters.value,
        selectedContentFilters.value,
        selectedStorytellerFilters.value]
    return allPickedFitlers.value + ' ' + result.filter(i => i !== '').join(', ')
})

const selectedTimeFilters = computed(() => {
    if (filterPageStore.storySearchModel.timeType === '1') {
        return filterPageStore.storySearchModel.yearsRange.join(' - ')
    }
    const keys = filterPageStore.storySearchModel.timeTags
    return (
        filterPageStore.timeTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const selectedLocationFilters = computed(() => {
    if (filterPageStore.storySearchModel.locationType === '1') {
        return filterPageStore.storySearchModel.locationQuery
    }
    const keys = filterPageStore.storySearchModel.locationTags
    return (
        filterPageStore.locationTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const selectedContentFilters = computed(() => {
    const keys = filterPageStore.storySearchModel.contentTags
    return (
        filterPageStore.contentTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

const selectedStorytellerFilters = computed(() => {
    const keys = filterPageStore.storySearchModel.storytellerTags
    return (
        filterPageStore.storytellerTags
            .filter((i) => keys.includes(i.Key))
            ?.map((i) => i.Name)
            ?.join(', ') ?? ''
    )
})

async function onSearchEnterClick() {
    filterPageStore.storySearchModel.query = searchQuery.value
}

const onSearchClick = () => {
    filterPageStore.storySearchModel.query = searchQuery.value
}

const clearSearch = () => {
    searchQuery.value = ""
    filterPageStore.storySearchModel.query = searchQuery.value
}

const onClearFilters = async() =>{
    filterPageStore.restFilters()
    router.replace({ query: undefined })
}
onMounted(async () => {
    window.addEventListener('scroll', handleScroll)

    filterPageStore.storySearchModel.query = router.currentRoute.value.query.query as string ?? ''
    searchQuery.value = filterPageStore.storySearchModel.query

    const dataKey = document.getElementById('vue-filter-page-component')?.attributes['data-model-key']?.value

    const storyId = router.currentRoute.value.query.storyId ?? dataKey

    if (storyId) {
        try {
            selectedStory.value = await filterPageStore.fetchStoryByKey(storyId.toString())
        } catch (error) {
            location.replace((error as Error).message)
        }
    }
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})

const handleScroll = async () => {
    const element = storyMosaic.value ?? null

    if (element && !isStoriesFethcing.value) {
        const scrollPos = element.getBoundingClientRect().bottom
        const scrollBottomBorder = (scrollPos * 70) / 100

        if (scrollBottomBorder < window.innerHeight) {
            await filterPageStore.getMoreStories()
        }
    }
}

async function onStoryClick(story: StoryDto) {
    selectedStory.value = story

    const queryParams = { ...router.currentRoute.value.query }
    await router.push({
        query: {
            ...queryParams,
            storyId: story.KeyId,
        },
    })
}

function manageVideoStates(videosStopped: boolean) {
    const videos = storyMosaic.value?.querySelectorAll('video')
    if (videos) {
        videos.forEach(video => {
            video.muted = true
            if (videosStopped) {
                video.pause()
            }
            else {
                video.play()
            }
        })
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(storiesDescr))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _unref(storiesDescr)
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = (e) => e.preventDefault())
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["search-input-wrapper", searchQuery.value ? 'active' : ''])
          }, [
            (searchQuery.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "clear",
                  onClick: clearSearch,
                  type: "button",
                  "aria-label": _unref(ariaLabelClearButton)
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              class: "search-input",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              "aria-label": _unref(ariaLabelSearch),
              placeholder: _unref(searchPlaceholder),
              onKeyup: _withKeys(onSearchEnterClick, ["enter"])
            }, null, 40, _hoisted_5), [
              [_vModelText, searchQuery.value]
            ]),
            _createElementVNode("button", {
              onClick: onSearchClick,
              class: "search",
              "aria-label": _unref(ariaLabelSearchButton)
            }, null, 8, _hoisted_6)
          ], 2),
          _createElementVNode("button", {
            "data-bs-toggle": "modal",
            "aria-haspopup": "dialog",
            "aria-label": _unref(isAnyFilters) ? _unref(selectedFilters) : _unref(filterPlaceholder),
            "data-bs-backdrop": "true",
            "data-bs-target": "#filter-search",
            class: _normalizeClass(["search-btn", [_unref(isAnyFilters) ? 'active' : '']]),
            type: "button"
          }, [
            _createTextVNode(_toDisplayString(_unref(filterPlaceholder)) + " ", 1),
            (_unref(isAnyFilters))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true)
          ], 10, _hoisted_7)
        ], 32),
        _createVNode(StoryCollectionsSearchModal)
      ]),
      (_unref(stories).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(resultsCountMessage)), 1),
                (_unref(isAnyFiltersPushed))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "overview-clear-btn clear",
                      onClick: onClearFilters
                    }, _toDisplayString(_unref(clearFiltersButton)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "stop-video-button",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((areVideosStopped).value = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (manageVideoStates(areVideosStopped.value))),
                  "aria-label": areVideosStopped.value ? _unref(playVideosText) : _unref(stopVideosText)
                }, null, 40, _hoisted_14), [
                  [_vModelCheckbox, areVideosStopped.value]
                ]),
                _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(stopVideosText)), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "d-flex story-mosaic-container",
              ref_key: "storyMosaic",
              ref: storyMosaic
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnsNumber), (outerIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "story-mosaic story-overview",
                  key: 'story-mosaic-' + outerIndex
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stories).filter((_, index) => (index % _unref(columnsNumber)) + 1 === outerIndex), (story) => {
                    return (_openBlock(), _createBlock(StoryPreviewItem, {
                      key: story.KeyId,
                      modelValue: story,
                      creationLink: _unref(landingPageLink),
                      isVideoPlaying: !areVideosStopped.value,
                      onHandleStoryClick: onStoryClick
                    }, null, 8, ["modelValue", "creationLink", "isVideoPlaying"]))
                  }), 128))
                ]))
              }), 128))
            ], 512)
          ]))
        : (!_unref(isStoriesFethcing))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_unref(noResultsText)), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_unref(tryAnotherWordText)), 1)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(StoryDetailsModal, {
      selectedStory: selectedStory.value,
      shareLinks: _unref(storiesShareLinks),
      pageTitle: _unref(storiesPageTitle)
    }, null, 8, ["selectedStory", "shareLinks", "pageTitle"])
  ], 64))
}
}

})